import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// components
import { Box } from '@mui/material';
// assets
import LogoImage from '../../../assets/newLogo.png';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink, sx }) {
  const logo = <Box sx={{ width: 120, height: 50, ...sx }}>{<img src={LogoImage} alt="Logo" />}</Box>;

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
